<template>
  <center>
    <h1>Pagina non trovata!</h1>
    <p>
      <a href="/">Torna alla homepage</a>
    </p>
  </center>
</template>

<script>

  export default {
    name: 'NotFound'
  }

</script>

<style scoped>

  center {
    margin: 15vw;
  }

  h1 {
    color: var(--border);
    font-size: 2em;
  }

</style>